module.exports = __webpack_public_path__ + "38d9154c7da6222630af52b68f4945ce.woff";